enum PageState {
    LOADING,
    SUCCESS,
    ERROR
}

export default PageState
